import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IFile, IKase, IKaseRelatedFiles } from '@/models';

import { http } from './http';

export const KaseFileApi = {
  updateKaseFiles: (
    kaseId: string | undefined,
    files: { files: IFile[] },
  ): Promise<AxiosResponse<IFile[]>> => {
    return http.patch(`api/${ApiVersion.V1}/kases/${kaseId}/files`, files);
  },
  // Append-only: adds generated print PDFs to the case files, including while
  // the case waits for approval.
  savePrintFiles: (
    kaseId: string | undefined,
    files: { files: IFile[] },
  ): Promise<AxiosResponse<IFile[]>> => {
    return http.post(`api/${ApiVersion.V1}/kases/${kaseId}/files/print`, files);
  },
  // This API returns all files uploaded in Cases pages (Names, Vehicles, ...), except the Files page
  getRelatedFiles: (
    kaseId: string,
  ): Promise<AxiosRequestConfig<IKaseRelatedFiles>> => {
    return http.get(`api/${ApiVersion.V1}/kases/${kaseId}/related-files`);
  },
  emailKaseFiles: (
    kaseId: string | undefined,
    data: IKaseFileEmailData,
  ): Promise<AxiosResponse<IKase>> => {
    return http.post(`api/${ApiVersion.V1}/kases/${kaseId}/files/email`, data);
  },
};

export interface IKaseFileEmailData {
  emailAddress: string;
  subject?: string;
  emailBody?: string;
  recipient?: string;
  reason?: string;
  files: IFile[];
}
